/*jslint browser: true, devel:true */
/*global define*/
import $ from 'jquery';
    

    const floatingLabels = {};

    //persistent labels pattern
    floatingLabels.setupPersistentLabels = function ($form) {
        // Persistent labels on fields
        $form.find('input').on('focus', function () {
            const input = $(this);
            const label = input.prev('label');
            input.data('holder', input.attr('placeholder'));
            input.attr('placeholder', '');
            label.addClass('input-wrap__label--show input-wrap__label--on');
        }).on('blur', function () {
            const input = $(this);
            const label = input.prev('label');
            if (this.value === '') {
                input.attr('placeholder', input.data('holder'));
                label.removeClass('input-wrap__label--show input-wrap__label--on');
            } else {
                label.removeClass('input-wrap__label--on');
            }
        });
    };

    export default floatingLabels;





// WEBPACK FOOTER //
// ./mobile-core/src/floating-labels.js